import React from "react";
import candyFruitMatch from "../image/candyFruitMatchKing.png";

export default function Home() {
  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-12 p-2">
          <div className="card">
            <img className="card-img-top" src={candyFruitMatch} alt="Card image cap" />
            <div className="card-body">
              <h5 className="card-title global_text_color">Candy Fruit Match King</h5>
              <a href="https://play.google.com/store/apps/details?id=com.free.game.candy.fruit.crush.puzzle" target="_blank" className="btn global_button">
                Want to play?
              </a>
            </div>
          </div>
        </div>
      </div>
      <p className="home_text p-2">We're just getting started. Our goal is to provide the best game experience with multiple games.</p>
    </div>
  );
}
